module.exports = __webpack_public_path__ + "img/icon_lock.020f065d.svg";